/**
 * @voltxampere/ui — Audio transformer 1:1 variant (Sprint 44-6, placeholder)
 *
 * PLACEHOLDER. 1:1 izolasyon transformer'ı — line-level audio
 * isolation (ground-loop break, DI box). Mevcut `inductor` stamp
 * üzerinden tek primary winding gösterir; secondary winding +
 * mutual inductance M coupling Sprint 47+ engine extension #4
 * ile (coupled inductor stamp).
 *
 * Reference: Generic 1:1 audio isolation transformer — Triad
 * TY-300P, Hammond 560G. 600 Ω : 600 Ω, 50 Hz - 20 kHz, ±0.5 dB
 * flatness. Profesyonel audio gear arası ground-loop kırma.
 *
 * Engine zero-diff invariant honored — canonical `inductor` engine
 * type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { inductor } from "../inductor.js";
export const transformerAudio1to1 = {
    id: "transformer-audio-1to1",
    nameTr: "Audio Transformer 1:1 (placeholder, primary)",
    nameEn: "Audio Transformer 1:1 (placeholder, primary)",
    shortcut: "L",
    category: "passive",
    viewBox: inductor.viewBox,
    terminals: inductor.terminals,
    defaultLabel: "T",
    defaultValue: "AUDIO-1:1",
    schemaType: "inductor",
    defaultParams: { inductance: 100e-3 },
    renderSVG: () => inductor.renderSVG(),
};
//# sourceMappingURL=transformer-audio-1to1.js.map